import * as _ from "lodash";
import * as React from "react";

import { LinkCard, LinkCardsProps } from "../../../Models";
import { CollapsibleCard, LinkCardContent } from "./";

const LinkCards: React.FC<LinkCardsProps> = (props: LinkCardsProps) => {
    return (
        <div className="Links">
            {_.map(
                props.cards.filter(
                    (c) =>
                        c.name.toLowerCase() !== "documents" &&
                        c.name.toLowerCase() !== "service visit reports"
                ),
                (linklist: LinkCard, index: Number) => {
                    let cardContent: JSX.Element = (
                        <LinkCardContent
                            selectLink={props.selectLink}
                            links={linklist.links}
                        />
                    );

                    return (
                        <CollapsibleCard
                            key={index.toString()}
                            title={linklist.name}
                            content={cardContent}
                        />
                    );
                }
            )}
        </div>
    );
};
export default LinkCards;
